export default __webpack_public_path__ + "static/media/empty-state-details.d23cc189.svg";